import React from "react";
import { CardContent } from "@material-ui/core";
import E_BillComparisonView from "./view/_bill_comparison_view";

export default function E_BillComparison() {
  return (
    <CardContent style={{height: "100%"}}>
        <E_BillComparisonView />
    </CardContent>
  );
}
